
require('./angular-numeric-directive');

var MODULE_NAME = 'numeric-directive';

angular.module(MODULE_NAME, ['purplefox.numeric']);

module.exports = MODULE_NAME;



// WEBPACK FOOTER //
// ./src/app/common/core/vendor/angular-numeric-directive/index.js